import { AgendaScenarioId } from '../constants';
import { useCalendarEventInteractionCallbacks } from '../hooks/useCalendarEventInteractionCallbacks';
import { observer } from 'mobx-react-lite';
import { AgendaEventsView } from 'owa-agenda-events-list';
import { CalendarPaneHeaderTimestrip, CalendarPaneHeaderWeather } from 'owa-calendar-pane-header';
import { formatShortWeekDayMonthDay, OwaDate } from 'owa-datetime';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { isWeatherAvailableForDate } from 'owa-weather';
import * as React from 'react';

const styles = require('./AgendaView.scss');

const AgendaView = observer(function AgendaView(props: { date: OwaDate }) {
    const { date } = props;

    const calendarEventInteractionCallback = useCalendarEventInteractionCallbacks();

    return (
        <div className={styles.container}>
            <div className={styles.agendaPaneHeader}>
                <CalendarPaneHeaderTimestrip
                    date={date}
                    textFormatter={formatShortWeekDayMonthDay}
                />
                {isHostAppFeatureEnabled('calendarPaneHeaderWeather') &&
                    isWeatherAvailableForDate(date) && <CalendarPaneHeaderWeather date={date} />}
            </div>
            <div className={styles.eventsView}>
                <AgendaEventsView
                    scenarioId={AgendaScenarioId}
                    callbacks={{ calendarEventInteractionCallback }}
                />
            </div>
        </div>
    );
});

export default AgendaView;
